<template>
  <div>
    <el-card>
      <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
        <el-form-item label="预约编号" prop="yuyue_bianhao">
          <el-input v-model="addForm.yuyue_bianhao" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="预约时间" >
          <el-date-picker v-model="addForm.yuyue_date" type="datetime"  placeholder="选择日期时间"  default-time="09:00:00">
      </el-date-picker>
        </el-form-item>
        <el-form-item label="请选择技师" prop="yunying_level">
            <el-select v-model="addForm.yuyue_yuangong_uid"  >
              <el-option v-for="item in yuangong_options" :key="item.uid" :label="item.yuangong_name+String.fromCharCode(58)+item.yuangong_mob"
                :value="item.uid"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="预约备注" prop="yuyue_memo">
          <el-input v-model="addForm.yuyue_memo"></el-input>
        </el-form-item>

      </el-form>

      <div style="text-align: center;" v-if="diaoyongType === 1">
        <el-button @click="quxiao">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import cheXingSelect from '../cheXing_select.vue'

export default {
  props: ['cheliang_uid', 'guest_uid', 'yuyue_bianhao', 'diaoyongType', 'caozuoType', 'editUid'], // diaoyongType 1 正常的界面管理调用 2 开单调用 editUid 如果有值，说明是修改
  data() {
    return {
      yuangong_options: [],
      addForm: {
        C_type: 'yuyue_add',
        yuyue_bianhao: '',
        yuyue_title: '',
        yuyue_memo: '',
        yuyue_date: '',
        cheliang_uid: 0,
        guest_uid: 0,
        yuyue_yuangong_uid: 0
      },
      addFormRules: {
        yuyue_date: [
            { required: true, message: '请输入预约时间', trigger: 'blur' }  
        ]
        
      }

    }
  },
  created() {
    this.addForm.yuyue_bianhao = this.yuyue_bianhao
    this.addForm.cheliang_uid = this.cheliang_uid
    this.addForm.guest_uid = this.guest_uid
    this.getYuangongList()
  },
  methods: {
    async getYuangongList() {
      const { data: res } = await this.$http.get('get_api', {
          params: { C_type: 'yuangong_list' }
        })
      console.log('test', JSON.parse(res.data)[0].dataList)
      this.yuangong_options = JSON.parse(res.data)[0].dataList;
    },
    quxiao() {
      if (this.diaoyongType === 1) this.$emit('getyuyueclose', this.Info)
    },
    async getBianhao_yuyue_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 15 }
      });
      // console.log(9999, JSON.parse(res.data)[0].bianhao_l)
      // console.log(JSON.parse(res.data)[0].bianhao_s);
      this.addForm.bianhao = JSON.parse(res.data)[0].bianhao_l;
    },
    add(callback) {
      var errFlag = 0
      this.$refs.addFormRef.validate(async valid => {
        if ((!valid) || (this.addForm.yuyue_date === 0 || this.addForm.yuyue_yuangong_uid === 0)) {
          errFlag = 1
          var data = {}
          this.$message.error('请添加必要的项目，再行递交')
          if (this.diaoyongType === 2) callback(errFlag, data)
          return 1;
        }
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const { data: res } = await this.$http.post('api', this.addForm)
        if (JSON.parse(res.data)[0].status === 200) this.$message.success('操作成功！');
        this.$emit('yuyueAddSuccess', 0)
        // if (this.caozuoType === 1) Info.uid = JSON.parse(res.data)[0].yuyue_uid
        // if (this.diaoyongType === 1) this.$emit('getyuyueNewUid', Info)
        // if (this.diaoyongType === 2) callback(errFlag, Info)
      });
    },
    resetForm() {
      // this.$refs.addFormRef.resetFields();
    }
  }
}
</script>
